import { ReactNode } from 'react';
import Chip from '../Chip';
import { ChipColors } from '../../../theme';

type BadgeVariant = 'success' | 'error' | 'warning' | 'info' | 'secondary';

type Props = {
  children: ReactNode;
  variant?: BadgeVariant;
  className?: string;
};

// Map badge variants to chip colors
const variantToChipColor: Record<BadgeVariant, ChipColors> = {
  success: 'green',
  error: 'red',
  warning: 'yellow',
  info: 'info',
  secondary: 'gray',
};

const Badge = ({ children, variant = 'secondary', className }: Props) => {
  const chipColor = variantToChipColor[variant];

  return <Chip title={children} color={chipColor} tooltip={undefined} />;
};

export default Badge;
